import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import './styles.scss';

export type ExternalLinkModalProps = {
  isVisible: boolean;
  skipModal: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  onSkipModalChange: (value: boolean) => void;
};

const ExternalLinkModal: React.FC<ExternalLinkModalProps> = ({
  isVisible,
  skipModal,
  onConfirm,
  onCancel,
  onSkipModalChange,
}) => {
  const { t } = useTranslation();
  return (
    <ElementsSDK.Modal
      className="stopover-external-link-modal"
      isVisible={isVisible}
      title={t('stopover.externalLink.modal.title')}
      size={ElementsSDK.ModalSize.EXTRA_LARGE}
      isCSSAnimationEnabled
      onClose={onCancel}
    >
      <ElementsSDK.Typography variant="p2">
        {t('stopover.externalLink.modal.description')}
      </ElementsSDK.Typography>

      <ElementsSDK.Checkbox
        className="stopover-external-link-modal__checkbox"
        checked={skipModal}
        onChange={onSkipModalChange}
        testid="stopover-external-link-modal-skip-checkbox"
        text={t('stopover.externalLink.modal.dontShowAgain')}
      />

      <div className="stopover-external-link-modal__actions">
        <ElementsSDK.Button
          data-testid="stopover-external-link-modal-cancel-btn"
          onClick={onCancel}
          type={'secondary'}
          outline={true}
        >
          {t('stopover.externalLink.modal.cancelButton')}
        </ElementsSDK.Button>
        <ElementsSDK.Button
          data-testid="stopover-external-link-modal-confirm-btn"
          onClick={onConfirm}
        >
          {t('stopover.externalLink.modal.continueButton')}
        </ElementsSDK.Button>
      </div>
    </ElementsSDK.Modal>
  );
};

export default ExternalLinkModal;
